import {
  moleculeStrengthOptionsInterface,
  portfolioOpportunitiesDataInterface,
} from 'Interfaces/BDPortalInterfaces';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { bdportalScreenServices } from 'services/bdportalScreenServices';
let frontendUrl;
if (import.meta.env.VITE_MODE == 'dev') {
  frontendUrl = import.meta.env.VITE_FRONTEND_ENDPOINT;
} else {
  frontendUrl = window.config.frontendBaseUrl;
}

const usePortfolioModalUploadAndValidation = () => {
  const [fileUploaded, setFiledUploaded] = useState(false);
  const [validationData, setValidationData] = useState<portfolioOpportunitiesDataInterface>([]);
  const [moleculeStrengthOptionsData, setMoleculeStrengthOptionsData] = useState<
    moleculeStrengthOptionsInterface[]
  >([]);
  const [isFileUploading, setIsFileUploading] = useState(false);

  const handleDownloadTemplate = () => {
    // Step 3: Create a link element
    const link = document.createElement('a');
    if (frontendUrl.length && frontendUrl[frontendUrl.length - 1] === '/') {
      link.href = `${frontendUrl}bd-portal/portfolio-opportunities-upload-template.xlsx`;
    } else {
      link.href = `${frontendUrl}/bd-portal/portfolio-opportunities-upload-template.xlsx`;
    }
    link.download = `portfolio-opportunities-upload-template.xlsx`; // Name of the file to download
    // Step 4: Append the link to the DOM, trigger click, and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleUploadFile = async (file: File) => {
    if (file) {
      try {
        setIsFileUploading(true);
        const formData = new FormData();
        formData.append('file', file);
        const preview_response =
          await bdportalScreenServices.getPortfolioOpportunitiesPreviewData(formData);

        setValidationData(preview_response.preview_data);
        setMoleculeStrengthOptionsData(preview_response.molecule_strengths);
        setFiledUploaded(true);
      } catch {
        toast.error(
          'The data file uploaded is not in the correct expected format, please verify it once and then upload'
        );
      } finally {
        setIsFileUploading(false);
      }
    }
  };

  return {
    fileUploaded,
    handleDownloadTemplate,
    validationData,
    isFileUploading,
    handleUploadFile,
    moleculeStrengthOptionsData,
  };
};

export default usePortfolioModalUploadAndValidation;
